export default {   
    ANNEXES: 'ANNEXES',
    DELEGATION: 'DELEGATION',
    ANNOUNCEMENT: 'ANNOUNCEMENT',
    PRIVATE: 'PRIVATE',
  };
